module.exports = __webpack_public_path__ + "img/subtract.86b9cf9d.png";